import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Login from './login'
import Home from './home'
import Sobre from './sobre'
import QuandoChamarSamu from './quando_chamar_samu'
import EditarPerfil from './editar_perfil'
import SolicitarAtendimento from './solicitar_atendimento'
import SolicitarAtendimentoFavorito from './solicitar_atendimento_favorito.js'
import Pacientes from './pacientes'
import AdicionarPaciente from './adicionar-paciente'
import EditarPaciente from './editar_paciente'
import VisualizarAtendimento from './visualizar-atendimento'
import CriarConta from './criar-conta'
import UltimasSolicitacoes from './ultima_solicitacao.js'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        Sobre,
        QuandoChamarSamu,
        EditarPerfil,
        SolicitarAtendimento,
        SolicitarAtendimentoFavorito,
        Pacientes,
        AdicionarPaciente,
        EditarPaciente,
        VisualizarAtendimento,
        CriarConta,
        UltimasSolicitacoes,
    ],
    /* scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    } */
});

router.beforeEach((to, from, next) => {
    const authenticated = localStorage.getItem('token');
    let to_splited = to.path.toString().split('/');
    to_splited = to_splited.filter(part => part !== '');

    if (!authenticated && to.path.toString() === '/criar-conta') {
        next(); // Permite o acesso à rota "/criar-conta" sem redirecionar
        return;
    }

    if (!authenticated && !['/login', '/criar-conta'].includes(to.path.toString())) {
        next('/login'); // Redireciona para "/login" se o usuário não estiver autenticado
        return;
    }

    if (authenticated && ['/login', '/criar-conta', '/'].includes(to.path.toString())) {
        next('/dashboard'); // Redireciona para "/dashboard" se o usuário já estiver autenticado e tentar acessar "/login" ou "/criar-conta"
        return;
    }

    next(); // Permite o acesso às outras rotas
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js